<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>Project</legend>

			<div class="form__group">
				<input id="project" name="project name" class="form__control" v-model="formData.projectName"
				       placeholder="Enter a name for the project..." v-validate required />
				<label for="project" class="form__label">Project name</label>
				<div class="form__validation">{{ errors.first('project name') }}</div>
			</div>

			<FormControlUser name="lead" v-model="formData.lead" label="Select lead user" v-validate="'required'">
			</FormControlUser>
			<FormControlUser name="team" v-model="formData.team" label="Additional users" :multiple="true"
			                 v-validate="'required'">
			</FormControlUser>

			<div class="form__group form__group--submit">
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import FormControlUser from '../../Form/Control/FormControlUser';
	import OpportunityFormStep from './OpportunityFormStep';
	import ValidationAlert from '../../ValidationAlert';

	export default {
		name: 'OpportunityFormStep1',
		mixins: [OpportunityFormStep],
		components: {
			ValidationAlert,
			FormControlUser,
		},
		data() {
			return {
				formData: {
					projectName: null,
					lead: null,
					team: [],
				}
			}
		},
	}
</script>
